import { useEffect, useRef, useState } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import { ccyFormat } from "../helpers/helper";

const Deposit = ({ maxQuantity, onClose, onConfirm }) => {
  const [quantity, setQuantity] = useState(0);
  const inputRef = useRef(null);

  useEffect(() => {
    setTimeout(() => inputRef.current?.focus(), 50);
  }, []);

  const isOver = quantity > maxQuantity;

  const handleConfirm = () => {
    if (!isOver) onConfirm && onConfirm(quantity);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') { e.preventDefault(); handleConfirm(); }
    if (e.key === 'Escape') { e.preventDefault(); onClose && onClose(); }
  };

  return (
    <Box display='flex' flexDirection='column' p={3} gap={2} onKeyDown={handleKeyDown}>
      <Typography variant="h6" fontWeight={700}>Seña</Typography>
      <Typography variant="body2" color="text.secondary">
        Máximo: <strong>${ccyFormat(maxQuantity)}</strong>
      </Typography>
      <TextField
        inputRef={inputRef}
        label="Monto de seña"
        type="number"
        value={quantity === 0 ? '' : quantity}
        onChange={(e) => {
          const v = Math.max(0, Number(e.target.value) || 0);
          setQuantity(v);
        }}
        error={isOver}
        helperText={isOver ? `No puede superar $${ccyFormat(maxQuantity)}` : 'Enter confirma · Esc cancela'}
        InputProps={{ startAdornment: <span style={{ marginRight: 4 }}>$</span> }}
        fullWidth
        inputProps={{ min: 0, max: maxQuantity }}
      />
      <Box display='flex' justifyContent='space-between' mt={1}>
        <Button variant="outlined" onClick={onClose}>Cancelar (Esc)</Button>
        <Button variant="contained" color="primary" disabled={isOver} onClick={handleConfirm}>
          Confirmar (Enter)
        </Button>
      </Box>
    </Box>
  );
};

export default Deposit;